import React from 'react'

import { useGoogleAnalyticsConfigurationQuery } from '../../modules/GoogleAnalytics'
import { AnalyticsTrackingPixelsView } from './AnalyticsTrackingPixelsView'
import { useAnalyticsTrackingPixels } from './hooks/useAnalyticsTrackingPixels'

export const AnalyticsTrackingPixelsContainer = () => {
  const { initialValues, onSubmit } = useAnalyticsTrackingPixels()
  const { googleAnalyticsConfigurationQuery } = useGoogleAnalyticsConfigurationQuery()

  return (
    <AnalyticsTrackingPixelsView
      initialValues={initialValues}
      isGoogleAnalyticsDisabled={googleAnalyticsConfigurationQuery.data?.type === 'CONNECTED'}
      onSubmit={onSubmit}
    />
  )
}
